module.exports = __webpack_public_path__ + "img/product_11.604ac78.webp";